import { render, staticRenderFns } from "./lead-footer.vue?vue&type=template&id=251e544f"
var script = {}
import style0 from "./lead-footer.vue?vue&type=style&index=0&id=251e544f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports